
export class SkillDetails {
    skill_code: number;
    skill_rating: number;
    skill_title: string;
    constructor(obj = {
        skill_code: 0,
        skill_rating: 0,
        skill_title: '',
    }) {
        this.skill_code = obj.skill_code || 0;
        this.skill_rating = obj.skill_rating || 0;
        this.skill_title = obj.skill_title || '';
    }
    setFormGroupData(obj) {
        this.skill_code = obj.skill_code || 0;
        this.skill_rating = obj.skill_rating || 0;
    }
    setData(obj) {
        this.skill_code = obj.skill_code || 0;

        this.skill_title = obj.skill_title || '';
        this.skill_rating = obj.skill_rating || 0;
    }
    getFormGroupData() {
        return {
            skill_code: this.skill_code || 0,


        }
    }

}